/* ── Palette: white + indigo + amber ── */
const C = {
  bg: "#ffffff",
  surface: "#f8fafc",
  border: "#e2e8f0",
  indigo: "#5664d2",
  indigoBg: "rgba(86,100,210,0.08)",
  indigoBdr: "rgba(86,100,210,0.25)",
  amber: "#fbbf24",
  amberBg: "rgba(251,191,36,0.08)",
  amberBdr: "rgba(251,191,36,0.35)",
  text: "#0f172a", // near-black
  sub: "#334155", // dark slate — readable
  dim: "#64748b", // medium slate — readable
  muted: "#94a3b8", // for very secondary labels only
  error: "#dc2626",
  errBg: "rgba(220,38,38,0.06)",
  mono: '"Fira Code","Cascadia Code","Consolas",monospace',
};

export default C;
